import React from "react";
import { DollarSign, PieChartIcon, TrendingUp, Target, Coins, Banknote, BarChart3, PiggyBank } from "lucide-react";

// Balance Sheet KPIs for 2024 based on the extended balance sheet
const balanceSheetKPIs = [
  {
    title: "Total Assets",
    value: "$3,670,000",
    change: "↑ 14% from last year",
    icon: <DollarSign className="h-6 w-6 text-green-500" />,
    textColor: "text-green-600",
  },
  {
    title: "Total Current Assets",
    value: "$1,670,000",
    change: "↑ 14.5% from last year",
    icon: <PieChartIcon className="h-6 w-6 text-blue-500" />,
    textColor: "text-blue-600",
  },
  {
    title: "Total Fixed Assets",
    value: "$2,000,000",
    change: "↑ 11.1% from last year",
    icon: <BarChart3 className="h-6 w-6 text-purple-500" />,
    textColor: "text-purple-600",
  },
  {
    title: "Total Liabilities",
    value: "$2,310,000",
    change: "↑ 12.7% from last year",
    icon: <Target className="h-6 w-6 text-red-500" />,
    textColor: "text-red-600",
  },
  {
    title: "Current Liabilities",
    value: "$1,090,000",
    change: "↑ 14.6% from last year",
    icon: <Coins className="h-6 w-6 text-orange-500" />,
    textColor: "text-orange-600",
  },
  {
    title: "Long-term Liabilities",
    value: "$1,220,000",
    change: "↑ 12% from last year",
    icon: <Banknote className="h-6 w-6 text-yellow-500" />,
    textColor: "text-yellow-600",
  },
  {
    title: "Total Equity",
    value: "$1,200,000",
    change: "↑ 9% from last year",
    icon: <TrendingUp className="h-6 w-6 text-teal-500" />,
    textColor: "text-teal-600",
  },
  {
    title: "Retained Earnings",
    value: "$700,000",
    change: "↑ 16.7% from last year",
    icon: <PiggyBank className="h-6 w-6 text-pink-500" />,
    textColor: "text-pink-600",
  },
  {
    title: "Common Stock",
    value: "$500,000",
    change: "No change from last year",
    icon: <BarChart3 className="h-6 w-6 text-indigo-500" />,
    textColor: "text-indigo-600",
  },
  {
    title: "Total Liabilities & Shareholder's Equity",
    value: "$3,670,000",
    change: "Matches total assets",
    icon: <Target className="h-6 w-6 text-green-500" />,
    textColor: "text-green-600",
  },
];

// Balance Sheet KPIs Component
const BalanceSheetKPIs = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-green-600" />
        <h3 className="text-lg font-medium text-gray-900">Balance Sheet KPIs (2024)</h3>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {balanceSheetKPIs.map((metric, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-6 hover:scale-105 transition-transform">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium text-gray-900">{metric.title}</h3>
              {metric.icon}
            </div>
            <p className="mt-3 text-2xl font-semibold text-gray-900">{metric.value}</p>
            <p className={`text-sm mt-1 ${metric.textColor}`}>{metric.change}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BalanceSheetKPIs;
